export default __webpack_public_path__ + "locales/fi/UploadPanel.json?hash=d696fce5f18755486bce55d0d181b3b7";